import React, { useEffect, useRef, useState } from 'react';
import './Dropdown.css';
import './AutocompleteField.css';

// Combobox com o mesmo visual de menu do Dropdown genérico (usado no
// seletor de concurso do topbar), mas com um <input> de texto livre como
// gatilho em vez de um botão — para os campos "matéria/assunto (existente
// ou nova)" que precisam tanto sugerir o catálogo quanto aceitar texto novo.
function AutocompleteField({ value, onChange, onSelectOption, options, ...inputProps }) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;

    const handleClickOutside = (event) => {
      if (rootRef.current && !rootRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') setOpen(false);
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [open]);

  const normalizedValue = value.trim().toLowerCase();
  const filteredOptions = options.filter((option) => option.toLowerCase().includes(normalizedValue));

  return (
    <div className="autocomplete-field" ref={rootRef}>
      <input
        {...inputProps}
        type="text"
        value={value}
        onChange={(e) => {
          onChange(e.target.value);
          setOpen(true);
        }}
        onFocus={(e) => {
          setOpen(true);
          inputProps.onFocus?.(e);
        }}
      />
      {open && filteredOptions.length > 0 && (
        <div className="dropdown-menu autocomplete-field-menu" role="listbox">
          {filteredOptions.map((option) => (
            <div
              key={option}
              role="option"
              aria-selected={false}
              className="dropdown-menu-item"
              // onMouseDown (não onClick) para disparar antes do blur do input,
              // senão o menu fecharia por causa do blur antes do clique registrar.
              onMouseDown={(e) => {
                e.preventDefault();
                onSelectOption(option);
                setOpen(false);
              }}
            >
              <span className="dropdown-menu-item-label">{option}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default AutocompleteField;
